import { AxiosResponse } from 'axios';
import { StableName } from '../../utils/racing-game/horses.ts';
import privateAxiosService from './privateAxiosService.ts';
import { HorseName } from '../../utils/racing-game/consts.ts';

// =================================
export type UserBets = {
  round: number;
  bets:
    | {
        [key in HorseName | StableName]: number;
      }
    | [];
};

export const getUserGameRoundBetsAPI = async (
  params?: { round?: number; currency_id?: Currency['id'] } & Record<string, unknown>
) => privateAxiosService.get<UserBets>('/game/mybets', { params });

// =================================
export const getUserNextGameRoundBetsAPI = async (
  params?: { currency_id?: Currency['id'] } & Record<string, unknown>
) =>
  privateAxiosService.get<undefined, UserBets>('game/mynextbets', {
    params,
  });

// =================================
export type PostUserBetResponse =
  | { error: true; code: string }
  | { error: false; message?: never };

export type PostUserBetParams = {
  bet: HorseName | StableName;
  amount: number;
  round: number;
  currency_id?: Currency['id'];
};

export const postUserBetAPI = async (params: PostUserBetParams) =>
  privateAxiosService.post<
    undefined,
    AxiosResponse<PostUserBetResponse>,
    PostUserBetParams
  >('game/bet', params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

// =================================
export type GetUserBalanceAPIResponse = {
  balance: string | number;
  currency_id?: Currency['id'];
};

export type GetUserBalanceAPIParams = {
  currency_id: Currency['id'];
};

export const getUserBalanceAPI = async (params: GetUserBalanceAPIParams) =>
  privateAxiosService.get<
    undefined,
    AxiosResponse<GetUserBalanceAPIResponse>,
    GetUserBalanceAPIParams
  >('user/balance', { params });
